
'use strict';

import React, {PropTypes} from 'react';

export default function CloneIcon(props) {

  const {
    className,
    ...otherProps
  } = props;

  return (
    <svg width="18px" height="22px" viewBox="0 0 18 22" version="1.1" xmlns="http://www.w3.org/2000/svg" className={`profile-icon ${className}`} {...otherProps}>
		<g id="2471---HR---Job-Request-Table-Clone" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g transform="translate(-1245.000000, -222.000000)" id="Group-21" strokeWidth="1.5" stroke="#333333">
				<g transform="translate(80.000000, 161.000000)">
					<g id="Group-17" transform="translate(990.000000, 0.000000)">
						<g id="Files_blank-files" transform="translate(176.000000, 62.000000)">
							<g id="Group-10">
								<polygon id="Shape" points="0 20 3.2 20 6.4 20 9.6 20 12.8 20 12.8 15.6666667 12.8 11.3333333 12.8 7.602 8.02488889 2.66666667 6.4 2.66666667 3.2 2.66666667 0 2.66666667 0 7 0 11.3333333 0 15.6666667"></polygon>
								<polyline id="Shape" points="7.82222222 3.33333333 7.82222222 8 12.0888889 8"></polyline>
								<polyline id="Shape" points="12.7111111 17.3333333 15.6444444 17.3333333 15.6444444 13 15.6444444 8.66666667 15.6444444 4.93533333 10.8693333 0 9.24444444 0 6.04444444 0 2.84444444 0 2.84444444 2.62533333"></polyline>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
  );

}



// WEBPACK FOOTER //
// ./shared/common/svgs/CloneIcon.js